import { Box, Grid } from '@mui/material';
import { useTheme } from '@emotion/react';
import { Outlet } from 'react-router-dom';

// SignupForm
import LoginArtAndSoraLogo from 'components/Forms/LoginForm/LoginArtAndSoraLogo';
import MobileLoginFallback from 'components/Forms/LoginForm/MobileLoginFallback';
import Footer from 'components/Footer/Footer';

function AuthLayout() {
	const SoraTheme = useTheme();

	return (
		<>
			<Box
				sx={{
					display: {
						xs: 'flex',
						sm: 'none'
					},
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					height: '90vh',
					background: SoraTheme.palette.gradient.gradient1
				}}
			>
				<MobileLoginFallback />
			</Box>
			<Box
				sx={{
					display: {
						xs: 'flex',
						sm: 'none'
					},
					height: '8vh'
				}}
			>
				<Footer />
			</Box>
			<Grid
				container
				sx={{
					justifyContent: 'space-between',
					height: '100vh',
					display: { xs: 'none', sm: 'flex' }
				}}
			>
				<Grid
					item
					xs={0}
					md={6}
					sx={{
						display: {
							xs: 'none',
							md: 'block'
						},
						height: '100vh',
						overflow: 'hidden'
					}}
				>
					<LoginArtAndSoraLogo />
				</Grid>

				<Grid
					container
					item
					xs={12}
					md={5}
					sx={{
						justifyContent: 'center',
						alignItems: 'center',
						height: '100vh',
						display: {
							xs: 'none',
							sm: 'flex'
						}
					}}
				>
					<Grid item xs={9} md={10}>
						<Outlet />
					</Grid>
				</Grid>
			</Grid>
		</>
	);
}

export default AuthLayout;
